import tw, { TwStyle } from 'twin.macro';

const Status = ({ statusText, statusStyle }: { statusText: string; statusStyle: TwStyle }) => {
  return (
    <div
      css={[
        tw`py-2 px-3 rounded-[100px] flex-row flex items-center justify-center gap-2 w-full h-[32px]`,
        statusStyle,
      ]}
    >
      <span tw="text-sm pt-1">{statusText}</span>
    </div>
  );
};

export default Status;
